<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <template>
            <v-card class="box">
                <v-toolbar class="toolbar no-display" flat dense>
                    <v-toolbar-title>
                        <strong>
                            Add Event
                        </strong>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row justify="center" dense>
                    <v-col sm="3">
                        <p><v-icon color="error">*</v-icon><b>Academic Year</b></p>
                        <v-combobox dense required v-model="academicyear" :items="ay_list" item-text="ay"
                            item-value="id" label="Academic Year" rounded outlined persistent-hint
                            hint="Please Select Academic Year" @change="getaystddivonrole()" />
                    </v-col>
                    <v-col sm="3">
                        <p><v-icon color="error">*</v-icon><b>Standard</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="standard" :items="standard_list"
                            item-text="standard" item-value="id" label="standard" multiple outlined persistent-hint
                            hint="Please Select Standard" @change="get_divisions()" />
                    </v-col>

                    <v-col sm="3">
                        <p><v-icon color="error">*</v-icon><b> Division</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="division" :items="division_list"
                            item-text="divname" item-value="id" label="Division" multiple outlined persistent-hint
                            hint="Please Select Division" />
                    </v-col>

                </v-row>
                <br />


                <span>
                    <v-row dense justify="center">
                        <v-col cols="6">
                            <v-text-field label="Title" v-model="title" :rules="textRule" required
                                placeholder="Please Enter Title">
                                <template v-slot:prepend>
                                    <v-icon color="red" size="15px"> mdi-asterisk </v-icon>
                                </template>


                            </v-text-field>
                        </v-col>

                        <v-col cols="12" sm="3">

                            <v-text-field outlined dense type="date" v-model="fromdate" label="From Date"
                                hint="From Date"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3">

                            <v-text-field outlined dense type="date" v-model="todate" label="To Date"
                                hint="To Date"></v-text-field>
                        </v-col>

                    </v-row>
                    <v-col cols="12">
                        <v-textarea label="Description" v-model="description" value placeholder="Enter description...."
                            hint="Enter description"></v-textarea>
                    </v-col>
                    <v-col cols="12">
                        <v-file-input v-model="attachments" placeholder="Upload attachment if any" label="Attachment"
                            multiple prepend-icon="mdi-paperclip">
                            <template v-slot:selection="{ text }">
                                <v-chip small label color="primary">{{ text }}</v-chip>
                            </template>
                        </v-file-input>
                    </v-col>


                </span>
                <br>
                <v-row justify="center">

                    <v-col cols="12" sm="2">

                        <v-btn @click="saveEvent()" :loading="save_btn_load" color="info">Save Event </v-btn>
                    </v-col>
                </v-row>
            </v-card>

            <v-card class="box">
                <v-data-table :headers="headers" :items="bookList1" :search="search">
                    <template v-slot:top class="pb-5">
                        <v-row dense justify="center" align="center">
                            <tr class="t-row">
                                <div>
                                    <th>
                                        <v-row>
                                            <span v-for="header in headers" :key="header.text">
                                                <span v-if="filters.hasOwnProperty(header.value)">
                                                    <v-autocomplete class="mr-2 pb-5 pt-2" flat hide-details small
                                                        rounded dense outlined color="#0F2027" :label="header.text"
                                                        multiple clearable :items="columnValueList(header.value)"
                                                        v-model="filters[header.value]"></v-autocomplete>
                                                </span>
                                            </span>
                                        </v-row>
                                    </th>
                                </div>
                            </tr>
                        </v-row>

                        <v-toolbar flat dense color="white">
                            <!-- <v-toolbar-title>Bank</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider> -->
                            <v-spacer></v-spacer><v-text-field v-model="search" append-icon="search" label="Search"
                                single-line hide-details> </v-text-field></v-toolbar>
                    </template>

                    <template v-slot:[`item.attachment`]="{ item }">
                        <span v-if="item.attachment && item.attachment.length > 0">
                            <div v-for="(attachment, index) in item.attachment" :key="index"
                                style="margin-bottom: 8px;">
                                <a :href="basepath + attachment.link" target="_blank">Attachment {{ index + 1 }}</a>
                            </div>
                        </span>
                        <span v-else>-</span>
                    </template>
                </v-data-table>
            </v-card>








        </template>
        <div class="text-center">
            <v-dialog v-model="init_loader" hide-overlay persistent width="300">
                <v-card color="primary" dark>
                    <v-card-text>
                        Please Wait
                        <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </div>
    </div>
</template>
<script>
import axios from "axios";
export default {
    data: () => ({
        file_upload_config: { allowed_type: "", max_size: 1000 },
        rules: [(value) => !value || value.size < 2000000 || "Logo size should be less than 2 MB!"],
        textRule: [(v) => !!v || "Field is required"],

        attachments: [],
        ay_list: [],
        eventInfoNew: [],
        academicyear: "",


        standard_list: [],
        standard: [],

        division_list: [],
        standard_list: [],
        division: [],

        datetime: null,
        search: "",
        searchQuery: "",
        snackbar_msg: "",
        snackbar: false,
        color: "",

        awspath: null,


        basepath: null,
        description: "",

        headers: [
            { text: "Academic Year", value: "ay" },
            { text: "Standard", value: "std" },
            { text: "Division", value: "div" },
            { text: "Title", value: "name" },
            { text: "From Date", value: "start" },
            { text: "To Date", value: "to_date" },
            { text: "Description", value: "description" },
            { text: "Attachment", value: "attachment" },

        ],

        filterArr: [],

        filters: {
            // std: [],
            ay: [],
            std: [],
            div: [],
            name: [],
        },
        title: null,



        status_dialog: false,
        save_btn_load: false,




        d_ay: null,

        init_loader: false,




        fromdate: new Date(new Date().getFullYear(), new Date().getMonth() - 0, 2).toISOString().substr(0, 10),
        todate: new Date().toISOString().slice(0, 10),
    }),
    watch: {},
    methods: {
        getFiltered(e) {
            this.filterArr = e;
        },
        columnValueList(val) {
            return this.eventInfoNew.map((d) => d[val]);
        },
        onLoad() {
            axios
                .post("Communication/getAdminEvent")
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.ay_list = res.data.ay_list;
                        this.eventInfoNew = res.data.eventInfoNew;

                        this.init_loader = false;
                    } else {

                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                })

        },
        getaystddivonrole() {
            const data = {
                ay: this.academicyear.id,
            };
            this.init_loader = true;
            axios
                .post("/Communication/get_ay_std_div_on_role_communication", data)
                .then((res) => {
                    if (res.data.flag == "YES") {

                        this.standard_list =
                            res.data.data;
                        this.division_list = this.standard_list.flatMap(standard => standard.div_list);

                    } else {

                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.init_loader = false;
                })
                .catch((error) => {
                    this.onerror(error);

                    this.init_loader = false;
                })
                .finally(() => {
                    this.init_loader = false;
                });
        },
        get_divisions() {

            const formData = {
                ay: this.academicyear.id,
                standard: this.standard,
            };
            this.division = [];
            axios
                .post("/Communication/get_standard_divisions", formData)
                .then((res) => {
                    if (res.data.flag == "Yes") {
                        this.division_list = res.data.division_list;
                    }
                })


        },
        hasWhiteSpace(s) {
            var status = false;
            var reWhiteSpace = new RegExp(/^\s+$/);

            // Check for white space
            if (reWhiteSpace.test(s)) {
                // alert("Please Check Your Fields For Spaces");
                return true;
            }
            return false;
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        saveEvent() {
            this.save_btn_load = true;
            let formData = new FormData();
            for (var i = 0; i < this.attachments.length; i++) {
                let file = this.attachments[i];

                formData.append("files", file);
            }
            for (var i = 0; i < this.division.length; i++) {
                let division = this.division[i];
                formData.append("div", division);
            }
            for (var i = 0; i < this.standard.length; i++) {
                let standard = this.standard[i];
                formData.append("standard", standard);
            }

            formData.append("event", "Communication");
            formData.append("type", "Event");
            formData.append("ay", this.academicyear.id);
            formData.append("description", this.description);
            formData.append("eventdate", this.fromdate);
            formData.append("todate", this.todate);
            formData.append("title", this.title);
            axios
                .post("/Communication/putAdminEvent", formData)
                .then((res) => {
                    if (res.data.status == "SUCCESS") {
                        this.showSnackbar("#4caf50", "Event Added Successfully..."); // show snackbar on success
                        this.save_btn_load = false;
                        this.attachments = [];
                        this.division = [];
                        this.standard = [];
                        this.academicyear = [];
                        this.description = '';
                        this.fromdate = '';
                        this.todate = '';
                        this.title = '';
                        this.onLoad();
                    } else {
                        this.showSnackbar("#b71c1c", res.data.status_reason); // show snackbar
                        //alert(res.data.status_reason)
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    window.console.log(error);
                })
                .finally(() => {
                    this.save_btn_load = false;
                });
        },

    },
    computed: {
        bookList1() {
            return this.eventInfoNew.filter((d) => {
                return Object.keys(this.filters).every((f) => {
                    return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
                });
            });
        },
    },
    mounted() {
        this.init_loader = true;
        this.onLoad();
        this.basepath = localStorage.getItem("awspath");
    },

};
</script>
<style scoped>
.allot-btn,
.allot-icon,
.info-icon {
    transition: 0.3s;
}

.allot-btn:hover .allot-icon {
    color: white;
}

.allot-btn:hover {
    background-color: #193a9a !important;
    border-color: #193a9a !important;
    color: white;
}

.info-icon:hover {
    background-color: #193a9a !important;
    border-color: #193a9a !important;
    color: white;
    border-radius: 100%;
}

.table-sub-title {
    margin-left: 1%;
    font-weight: 500;
    color: #999;
}

@media print {
    body {
        height: 100%;
        width: 100%;
    }

    .no-display {
        display: none !important;
    }

    .v-data-footer,
    .v-data-footer__select,
    .v-data-footer__pagination {
        display: none !important;
        visibility: hidden !important;
    }

    .v-data-table table,
    .v-data-table__wrapper {
        width: 100% !important;
        display: block !important;
    }

    table,
    th,
    td {
        border-collapse: collapse !important;
        border: 1px solid black !important;
        width: 100%;
        text-align: right !important;
    }
}

.box1 {
    height: 100%;
}
</style>
